















































































import Component from 'vue-class-component';

// Steps and step types
import Steps from './../steps';
import { Step, StepConfig } from './../types';

// The base class for every step
import BaseStep from '../BaseStep.vue';

/**
 *  The introduction: introducing the user to the tool
 *  and explaining what's going to happen.
 */
@Component
export default class Intro extends BaseStep {

    /**
     *  Forward the available steps to the tpl to render.
     */
    private steps = Steps;

    /**
     *  Used to get the config of the first step of
     *  the tool: configuring the spaces.
     */
    private get firstStep(): StepConfig {

        return Steps[Step.Spaces];

    }

    /**
     *  Used to start the process of requesting an offer:
     *  navigating the user to the first step.
     */
    private start(): void {

        void this.$router.push(Step.Spaces);

    }

}
